// Demo page entry point

import { initSwiperDemoWithResize } from './swiper-demo.js';

// ─── Swiper ───────────────────────────────────────────────────────────────────

initSwiperDemoWithResize();
